export const statistics = {
  offensive: [
    {
      playerId: 'civ-fw-009',
      name: 'Sébastien Haller',
      number: 9,
      position: 'FW',
      image: 'https://cdn.example.com/players/civ-fw-009.png',
      stats: [
        { code: 'G', codeName: 'goals', value: 8 },
        { code: 'PAG', codeName: 'assists', value: 8 },
        { code: 'TT', codeName: 'shotsTotal', value: 8 },
        { code: 'TAP', codeName: 'shotsOnGoal', value: 8 },
        { code: 'RE', codeName: 'successfulDribbles', value: 9 },
        { code: 'FR', codeName: 'foulsReceived', value: 8 },
        { code: 'FJ', codeName: 'offsides', value: 2 },
      ],
    },
    {
      playerId: 'civ-fw-019',
      name: 'Nicolas Pépé',
      number: 19,
      position: 'FW',
      image: 'https://cdn.example.com/players/civ-fw-019.png',
      stats: [
        { code: 'G', codeName: 'goals', value: 7 },
        { code: 'PAG', codeName: 'assists', value: 6 },
        { code: 'TT', codeName: 'shotsTotal', value: 8 },
        { code: 'TAP', codeName: 'shotsOnGoal', value: 6 },
        { code: 'RE', codeName: 'successfulDribbles', value: 8 },
        { code: 'FR', codeName: 'foulsReceived', value: 7 },
        { code: 'FJ', codeName: 'offsides', value: 2 },
      ],
    },
    {
      playerId: 'civ-fw-024',
      name: 'Simon Adingra',
      number: 24,
      position: 'FW',
      image: 'https://cdn.example.com/players/civ-fw-024.png',
      stats: [
        { code: 'G', codeName: 'goals', value: 6 },
        { code: 'PAG', codeName: 'assists', value: 5 },
        { code: 'TT', codeName: 'shotsTotal', value: 8 },
        { code: 'TAP', codeName: 'shotsOnGoal', value: 6 },
        { code: 'RE', codeName: 'successfulDribbles', value: 7 },
        { code: 'FR', codeName: 'foulsReceived', value: 6 },
        { code: 'FJ', codeName: 'offsides', value: 1 },
      ],
    },
    {
      playerId: 'civ-fw-013',
      name: 'Jérémie Boga',
      number: 13,
      position: 'FW',
      image: 'https://cdn.example.com/players/civ-fw-013.png',
      stats: [
        { code: 'G', codeName: 'goals', value: 5 },
        { code: 'PAG', codeName: 'assists', value: 5 },
        { code: 'TT', codeName: 'shotsTotal', value: 7 },
        { code: 'TAP', codeName: 'shotsOnGoal', value: 5 },
        { code: 'RE', codeName: 'successfulDribbles', value: 6 },
        { code: 'FR', codeName: 'foulsReceived', value: 5 },
        { code: 'FJ', codeName: 'offsides', value: 1 },
      ],
    },
    {
      playerId: 'civ-fw-007',
      name: 'Jonathan Bamba',
      number: 7,
      position: 'FW',
      image: 'https://cdn.example.com/players/civ-fw-007.png',
      stats: [
        { code: 'G', codeName: 'goals', value: 4 },
        { code: 'PAG', codeName: 'assists', value: 4 },
        { code: 'TT', codeName: 'shotsTotal', value: 6 },
        { code: 'TAP', codeName: 'shotsOnGoal', value: 4 },
        { code: 'RE', codeName: 'successfulDribbles', value: 5 },
        { code: 'FR', codeName: 'foulsReceived', value: 4 },
        { code: 'FJ', codeName: 'offsides', value: 1 },
      ],
    },
    {
      playerId: 'civ-fw-014',
      name: 'Oumar Diakité',
      number: 14,
      position: 'FW',
      image: 'https://cdn.example.com/players/civ-fw-014.png',
      stats: [
        { code: 'G', codeName: 'goals', value: 3 },
        { code: 'PAG', codeName: 'assists', value: 3 },
        { code: 'TT', codeName: 'shotsTotal', value: 5 },
        { code: 'TAP', codeName: 'shotsOnGoal', value: 3 },
        { code: 'RE', codeName: 'successfulDribbles', value: 4 },
        { code: 'FR', codeName: 'foulsReceived', value: 3 },
        { code: 'FJ', codeName: 'offsides', value: 0 },
      ],
    },
  ],
  defensive: [
    {
      playerId: 'civ-df-021',
      name: 'Evan Ndicka',
      number: 21,
      position: 'DF',
      image: 'https://cdn.example.com/players/civ-df-021.png',
      stats: [
        { code: 'I', codeName: 'interceptions', value: 10 },
        { code: 'EG', codeName: 'tacklesWon', value: 7 },
        { code: 'FC', codeName: 'foulsCommitted', value: 6 },
        { code: 'TA', codeName: 'yellowCards', value: 2 },
      ],
    },
    {
      playerId: 'civ-df-005',
      name: 'Willy Boly',
      number: 5,
      position: 'DF',
      image: 'https://cdn.example.com/players/civ-df-005.png',
      stats: [
        { code: 'I', codeName: 'interceptions', value: 9 },
        { code: 'EG', codeName: 'tacklesWon', value: 7 },
        { code: 'FC', codeName: 'foulsCommitted', value: 5 },
        { code: 'TA', codeName: 'yellowCards', value: 2 },
      ],
    },
    {
      playerId: 'civ-df-017',
      name: 'Serge Aurier',
      number: 17,
      position: 'DF',
      image: 'https://cdn.example.com/players/civ-df-017.png',
      stats: [
        { code: 'I', codeName: 'interceptions', value: 8 },
        { code: 'EG', codeName: 'tacklesWon', value: 6 },
        { code: 'FC', codeName: 'foulsCommitted', value: 5 },
        { code: 'TA', codeName: 'yellowCards', value: 3 },
      ],
    },
    {
      playerId: 'civ-df-003',
      name: 'Ghislain Konan',
      number: 3,
      position: 'DF',
      image: 'https://cdn.example.com/players/civ-df-003.png',
      stats: [
        { code: 'I', codeName: 'interceptions', value: 8 },
        { code: 'EG', codeName: 'tacklesWon', value: 6 },
        { code: 'FC', codeName: 'foulsCommitted', value: 4 },
        { code: 'TA', codeName: 'yellowCards', value: 2 },
      ],
    },
    {
      playerId: 'civ-df-018',
      name: 'Wilfried Singo',
      number: 18,
      position: 'DF',
      image: 'https://cdn.example.com/players/civ-df-018.png',
      stats: [
        { code: 'I', codeName: 'interceptions', value: 7 },
        { code: 'EG', codeName: 'tacklesWon', value: 5 },
        { code: 'FC', codeName: 'foulsCommitted', value: 4 },
        { code: 'TA', codeName: 'yellowCards', value: 2 },
      ],
    },
    {
      playerId: 'civ-df-007',
      name: 'Odilon Kossounou',
      number: 7,
      position: 'DF',
      image: 'https://cdn.example.com/players/civ-df-007.png',
      stats: [
        { code: 'I', codeName: 'interceptions', value: 7 },
        { code: 'EG', codeName: 'tacklesWon', value: 5 },
        { code: 'FC', codeName: 'foulsCommitted', value: 3 },
        { code: 'TA', codeName: 'yellowCards', value: 1 },
      ],
    },
  ],
  goalkeeping: [
    {
      playerId: 'civ-gk-001',
      name: 'Yahia Fofana',
      number: 1,
      position: 'GK',
      image: 'https://cdn.example.com/players/civ-gk-001.png',
      stats: [
        { code: 'SV', codeName: 'savesByPlayer', value: 8 },
        { code: 'CS', codeName: 'cleanSheets', value: 3 },
      ],
    },
  ],
};
